import menuRoutes from './routes'

export default menuRoutes
